// chat.tsx

import styles from './chat.module.scss';
import Logout from '@mui/icons-material/Logout';

import { useEffect, useState, useContext } from 'react';
import { InitalChatRequest, ChatUserContext, iChatUserContext } from '../../core/chatContext';
import { loginUser, logoutUser } from '../../core/users';
import { ChatController } from '../../components/chat/chat.controller';

import { MenuComponent } from '../../components/common/menu/main';
import { NewChatComponent } from '../../components/common/newChat/newChat';
import { HistoryComponent } from '../../components/history/history';
import { ChatComponent } from '../../components/chat/chat';


import { NOT_AUTH_USER, GenovAi_ID } from '../../configuration/genovAiConfig';

import { LogoTel } from '../../assets/svg/logoTel';

import { useMsal } from '@azure/msal-react';
import { FooterComponent } from '../../components/chat/footer/footer';
import { MenuContext } from '../../context/menuContext';
import { useNavigate } from 'react-router-dom';



const ChatPage: React.FC<{ userId: string, userChatIdx: UserProfile | null, accessToken: string | null }> = ({ userId, userChatIdx, accessToken = null }) => {

  const [currChat, setCurrChat] = useState(InitalChatRequest);
  const [currHistory, setCurrHistory] = useState([]);
  const [userAsks, setUserAsks] = useState([] as Array<string>);
  const [iaAnswers, setIaAnswers] = useState([] as DialogComponents[]);
  const [loading, setLoading] = useState(false);
  const [filesSelected, setFilesSelected] = useState<any[]>([]);
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const [isResponseProcess, setIsResponseProcess] = useState<boolean>(false);

  const { isMenuOpen, mail } = useContext(MenuContext);

  const navigate = useNavigate();

  useEffect(() => {

    const _registerUser = async () => {
      try {
        await loginUser(GenovAi_ID, userId, mail);
        // Aquí continúas con la lógica normal si la autenticación fue exitosa
      } catch (error) {
        if (error instanceof Error && 'status' in error && (error as any).status === 403) {
          navigate('/no-access');
          console.log("No hay permisos")
        } else {
          console.log("error")
          console.error('Error inesperado:', error);
        }
      }
    }

    const _handleBeforeUnload = async () => {
      if (currChat.data_sources[0].parameters.ephemeralId) {
        const Chat_Controller = new ChatController()
        await Chat_Controller.RemoveFile(currChat.data_sources[0].parameters.ephemeralId);
      };
      logoutUser(GenovAi_ID, userId);
    };

    // Register login user
    _registerUser();

    // Add user index to request parameters to call openai api
    setCurrChat((currChat: RequestOpenAI) => {
      if (userChatIdx?.index) {
        currChat.data_sources[0].parameters.index_name = userChatIdx.index;
        currChat.data_sources[0].parameters.semantic_configuration = userChatIdx.semanticConfiguration;
      }
      return currChat;
    });

    // Add event before unload
    window.addEventListener('beforeunload', _handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', _handleBeforeUnload);
    };
  }, [userChatIdx, userId, currChat]);

  const NotAutorizedComponent = () => {
    const { instance } = useMsal();

    const handleLogoutRedirect = () => {
      instance.logoutRedirect().catch((error) => console.log(error));
    };

    return (
      <div className={styles.chatError}>
        <div className={styles.chatErrorMessage}>{NOT_AUTH_USER}</div>
        <div className={styles.chatErrorLogOut} onClick={handleLogoutRedirect} role="button">
          <Logout></Logout>
          <span>Log Out</span>
        </div>
      </div>
    )
  }

  return (

    <ChatUserContext.Provider value={
      {
        currChat, setCurrChat,
        currHistory, setCurrHistory,
        userAsks, setUserAsks,
        iaAnswers, setIaAnswers,
        accessToken: accessToken,
        isLoading: loading,
        setIsLoading: (value) => setLoading(value),
        filesSelected, setFilesSelected,
        isUploading, setIsUploading,
        isResponseProcess, setIsResponseProcess,
      } as iChatUserContext
    }>

      <div className={styles.root}>
        <div className={styles.content}>
          <MenuComponent idUser={userId} status={true}>
            <div style={{ padding: "5px 2px" }}>
              <NewChatComponent></NewChatComponent>
            </div>
            <div style={{ opacity: isMenuOpen ? '1' : '0', transition: 'opacity .3s ease-in-out' }}><HistoryComponent idUser={userId}></HistoryComponent></div>
          </MenuComponent>
          <div className={styles.chatContainer}>
            <div className={styles.chatContainerHeader}>
              <div className={styles.logoTel}>
                <LogoTel />
              </div>
              <div className={styles.separator}>
                <a className={styles.enlaceManual} target='_blank' href="/Manual Usuario SophAI.pdf">Manual de Usuario</a>
              </div>
            </div>
            <ChatComponent idUser={userId} userPhoto={userChatIdx?.userPhoto} />
          </div>
        </div>
        <FooterComponent />

        {(userChatIdx?.authorizedUser && userChatIdx?.index) ? <></> : <NotAutorizedComponent />}
      </div>
    </ChatUserContext.Provider>
  )

}

export { ChatPage }
